import { render, staticRenderFns } from "./dashboard-table.vue?vue&type=template&id=585c46da"
import script from "./dashboard-table.vue?vue&type=script&lang=js"
export * from "./dashboard-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports